// 세션 만료 안내 다이얼로그 — 만료 시 로그인 화면 위에 뜨고, 확인을 누르면 닫힌다
import React from 'react';
import { AXButton, AXModal } from 'yukimushi-component-fe';
import { useAuth } from '../context/AuthContext';
import { useT } from '../lib/locale';

export default function SessionExpiredDialog() {
  const { sessionExpired, sessionExpiredUnsaved, dismissSessionExpired } = useAuth();
  const { t } = useT();

  return (
    <AXModal
      open={sessionExpired}
      onClose={dismissSessionExpired}
      title={t('sessionExpired.title')}
      width={420}
      footer={
        <AXButton variant="primary" onClick={dismissSessionExpired}>
          {t('sessionExpired.ok')}
        </AXButton>
      }
    >
      {t('sessionExpired.body')}
      {sessionExpiredUnsaved && (
        <div role="alert" style={{ marginTop: 8 }}>{t('sessionExpired.unsaved')}</div>
      )}
    </AXModal>
  );
}
